import React from 'react';
import ctaBg from '../../hero3-bg.jpg';
import { Target, Eye, Users, Award, Lightbulb, Shield } from 'lucide-react';
import { useEffect, useRef } from 'react';
import { Card, CardContent } from './ui/card';
import { ImageWithFallback } from './figma/ImageWithFallback';
import { useLanguage } from '../LanguageProvider';

export function AboutPage() {
  const { language } = useLanguage();
  const heroRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const $ = (window as any).jQuery as any;
    const pg = (window as any).particleground as any;
    if (!heroRef.current || !$.fn || !pg) return;
    const $el = (window as any).jQuery(heroRef.current);
    if ($el.data('pg-init')) return;
    $el.data('pg-init', true);
    $el.particleground({
      dotColor: 'rgba(93, 101, 107, 0.35)',
      lineColor: 'rgba(93, 101, 107, 0.35)',
      parallax: true,
      parallaxMultiplier:50
    });
    return () => { try { $el.particleground('destroy'); } catch {} };
  }, []);

  const texts = {
    tr: {
      heroTitle: 'Hakkımızda',
      heroDescription: '2011 yılından beri teknoloji ve inovasyon alanında faaliyet gösteren İlimera Teknoloji, elektronik ve yazılım çözümleri konusunda uzman bir şirkettir.',
      stats: [
        { label: 'Yıllık Deneyim', value: '15+' },
        { label: 'Tamamlanan Proje', value: '50+' },
        { label: 'Memnun Müşteri', value: '520+' },
        { label: 'Teknoloji Alanı', value: '5' }
      ],
      ceoDescription: 'Vizyoner bir teknoloji lideri olan YILDIZHAN, kurucusu olduğu İlimera Teknoloji\'de 15 yılı aşkın deneyimini stratejik öngörü ve girişimcilik ruhuyla birleştirerek şirketin yol haritasını şekillendirmektedir. Uluslararası ticaret uzmanlığıyla küresel pazarlarda etkin rol üstlenirken, akıcı İngilizce ve Fransızcasıyla iş birliklerini başarıyla yönetmektedir. Bilgisayar Mühendisliği yüksek lisansına devam ederken Tıp Fakültesi dersleriyle disiplinler arası bilgisini genişletmektedir. Dalgıç eğitmenliği ve Milli Savunma Bakanlığı\'ndaki mihmandarlık görevleriyle edindiği liderlik, disiplin ve temsil tecrübeleri, ona teknoloji geliştirme ve sürdürülebilir inovasyonda ilham veren bir bakış açısı kazandırmaktadır.',
      ceoMessageTitle: 'CEO\'muzdan Mesaj',
      ceoMessage: '"İlimera Teknoloji olarak, teknolojinin insanlığa hizmet etmesi gerektiğine inanıyoruz. Her projemizde müşterilerimizin ihtiyaçlarını anlamaya odaklanıyor ve onlara değer katacak çözümler geliştiriyoruz. Amacımız sadece teknoloji üretmek değil, aynı zamanda iş hayatını kolaylaştıran, verimlilik artıran ve sürdürülebilir çözümler sunmaktır. Ekibimizle birlikte bu vizyonu gerçekleştirmek için çalışmaya devam ediyoruz."',
      ceoSignatureTitle: 'Kurucu & CEO',
      storyTitle: 'Şirketimizin Hikayesi',
      storyParagraph1: '2011 yılında Demirekin Yazılım adıyla başlayan girişimcilik yolculuğumuz, 13 yılı aşkın tecrübe ile ulusal ve uluslararası ölçekte 500\'den fazla müşteriye hizmet sunmaya devam etmektedir. 2024 yılında elektronik ve ileri teknoloji geliştirme vizyonuyla yeni ortaklık yapısı altında İLİMERA Teknoloji markasıyla yolumuza güçlenerek devam ediyoruz.',
      storyParagraph2: 'Şirketimiz; endüstriyel otomasyon, IoT çözümleri ve akıllı cihaz teknolojileri alanlarındaki birikimlerini bir araya getirerek çözüm odaklı hizmetler sunmaktadır. Bugün elektronik tasarım, yazılım geliştirme, sistem entegrasyonu ve proje yönetimi konularında faaliyet gösteren İLİMERA Teknoloji, müşteri odaklı yaklaşımı ile sektörde güvenilir bir iş ortağı olmayı başarmıştır.',
      storyParagraph3: 'Sürekli yürüttüğümüz Ar-Ge faaliyetleri sayesinde yenilikçi çözümler geliştirmeye devam ediyoruz. Amacımız, teknolojinin gücünü kullanarak hayatı kolaylaştıran, verimli ve sürdürülebilir çözümler üretmek ve iş dünyasında fark oluşturan bir teknoloji lideri olmaktır.',
      missionTitle: 'Misyonumuz',
      missionDescription: 'Teknolojinin gücünü kullanarak, müşterilerimizin iş süreçlerini optimize eden, verimlilik artıran ve güvenilir çözümler geliştirmek. İnovatif yaklaşımımızla sektörde öncü olmaya devam etmek ve teknoloji ile hayatı kolaylaştırmak.',
      visionTitle: 'Vizyonumuz',
      visionDescription: 'Yerli ve milli teknolojiler geliştirerek global pazarda söz sahibi bir teknoloji şirketi olmak. Ar-Ge faaliyetlerimizi sürdürerek dünya standartlarında ürünler üretmek ve Türkiye\'yi teknoloji ihracatında öncü ülkeler arasına taşımak.',
      valuesTitle: 'Değerlerimiz',
      valuesDescription: 'Şirketimizi yönlendiren temel değerler ve ilkeler',
      values: [
        {
          icon: Lightbulb,
          title: 'İnovasyon',
          description: 'Sürekli araştırma ve geliştirme ile sektörde öncü teknolojiler üretiyoruz.'
        },
        {
          icon: Shield,
          title: 'Güvenilirlik',
          description: 'Kaliteli ve dayanıklı çözümlerle müşteri güvenini kazanıyoruz.'
        },
        {
          icon: Users,
          title: 'Müşteri Odaklılık',
          description: 'Her ürünü müşteri ihtiyaçlarına özel olarak tasarlıyoruz.'
        },
        {
          icon: Award,
          title: 'Kalite',
          description: 'Uluslararası standartlarda ürün ve hizmet kalitesi sunuyoruz.'
        }
      ]
    },
    en: {
      heroTitle: 'About Us',
      heroDescription: 'İlimera Technology, operating in technology and innovation since 2011, is a company specialized in electronic and software solutions.',
      stats: [
        { label: 'Years of Experience', value: '15+' },
        { label: 'Completed Projects', value: '50+' },
        { label: 'Satisfied Customers', value: '520+' },
        { label: 'Technology Fields', value: '5' }
      ],
      ceoDescription: 'YILDIZHAN, a visionary technology leader, shapes the company\'s roadmap by combining over 15 years of experience with strategic foresight and entrepreneurial spirit at İlimera Technology, which he founded. While playing an active role in global markets with his international trade expertise, he successfully manages collaborations with fluent English and French. He is expanding his interdisciplinary knowledge with Medical School courses while continuing his Master\'s in Computer Engineering. His leadership, discipline, and representation experiences gained through diving instructor and liaison duties at the Ministry of National Defense have given him a perspective that inspires technology development and sustainable innovation.',
      ceoMessageTitle: 'Message from Our CEO',
      ceoMessage: '"As İlimera Technology, we believe that technology should serve humanity. In every project, we focus on understanding our customers\' needs and developing solutions that add value to them. Our goal is not only to produce technology, but also to provide solutions that make business life easier, increase efficiency, and are sustainable. We continue to work with our team to realize this vision."',
      ceoSignatureTitle: 'Founder & CEO',
      storyTitle: 'Our Company Story',
      storyParagraph1: 'Our entrepreneurial journey, which began in 2011 under the name Demirekin Yazılım, continues to serve more than 500 customers on a national and international scale with over 13 years of experience. In 2024, we continue our journey with strengthened momentum under the İLİMERA Technology brand with a new partnership structure, with the vision of developing electronics and advanced technology.',
      storyParagraph2: 'Our company provides solution-oriented services by combining its expertise in industrial automation, IoT solutions, and smart device technologies. İLİMERA Technology, which operates today in electronic design, software development, system integration, and project management, has succeeded in becoming a trusted business partner in the industry with its customer-focused approach.',
      storyParagraph3: 'Thanks to our ongoing R&D activities, we continue to develop innovative solutions. Our goal is to produce efficient and sustainable solutions that make life easier using the power of technology and to become a technology leader that makes a difference in the business world.',
      missionTitle: 'Our Mission',
      missionDescription: 'To develop reliable solutions that optimize our customers\' business processes and increase efficiency using the power of technology. To continue to be a pioneer in the industry with our innovative approach and to make life easier with technology.',
      visionTitle: 'Our Vision',
      visionDescription: 'To become a technology company with a say in the global market by developing local and national technologies. To produce world-class products by continuing our R&D activities and to move Turkey among the leading countries in technology exports.',
      valuesTitle: 'Our Values',
      valuesDescription: 'The core values and principles that guide our company',
      values: [
        {
          icon: Lightbulb,
          title: 'Innovation',
          description: 'We produce pioneering technologies in the industry through continuous research and development.'
        },
        {
          icon: Shield,
          title: 'Reliability',
          description: 'We earn customer trust with quality and durable solutions.'
        },
        {
          icon: Users,
          title: 'Customer Focus',
          description: 'We design every product specifically for customer needs.'
        },
        {
          icon: Award,
          title: 'Quality',
          description: 'We offer product and service quality at international standards.'
        }
      ]
    }
  } as const;

  const t = texts[language] ?? texts.tr;

  return (
    <div>
      {/* Hero Section */}
      <section className="relative py-16 lg:pt-20 lg:pb-20 overflow-hidden">
        {/* Background image */}
        <div aria-hidden className="absolute inset-0 z-0 bg-cover bg-center" style={{ backgroundImage: `url(${ctaBg})` }}></div>
        {/* Dark overlay */}
        <div aria-hidden className="absolute inset-0 z-[5] bg-black/45"></div>
        {/* Particles above overlay */}
        <div ref={heroRef} className="absolute inset-0 z-10 pointer-events-none"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-20">
          <div className="text-center">
            <h1 
              className="text-4xl lg:text-5xl font-bold text-white mb-6 about-title"
            >
              {t.heroTitle}
            </h1>
            <p 
              className="text-lg text-white max-w-3xl mx-auto about-description"
            >
              {t.heroDescription}
            </p>
          </div>
        </div>
      </section>
      {/* CEO Section */}
      <section className="py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="text-center lg:text-left">
              <div className="w-48 h-48 mx-auto lg:mx-0 mb-6">
                <ImageWithFallback
                  src="pp_2.jpg"
                  alt="CEO"
                  className="w-full h-full object-cover rounded-full"
                />
              </div>
              <h3 
                className="text-2xl font-bold text-gray-900 mb-2 ceo-name"
                style={{ color: 'var(--foreground)' }}
              >
                Alpaslan YILDIZHAN
              </h3>
              <p 
                className="text-gray-600 leading-relaxed ceo-description"
                style={{ color: 'var(--foreground)' }}
              >
                {t.ceoDescription}
              </p>
            </div>

            <div>
              <Card className="p-8 bg-card dark:border-gray-700">
              <div className="mt-12">                </div>
                <h4 
                  className="text-xl font-bold text-gray-900 mb-4 ceo-message-title"
                  style={{ color: 'var(--foreground)' }}
                >
{t.ceoMessageTitle}
                </h4>
                <blockquote 
                  className="text-gray-600 italic leading-relaxed ceo-message"
                  style={{ color: 'var(--foreground)' }}
                >
{t.ceoMessage}
                </blockquote>
                <div className="mt-6">
                  <p 
                    className="font-semibold text-gray-900 ceo-signature-name"
                    style={{ color: 'var(--foreground)' }}
                  >
                    Alpaslan YILDIZHAN
                  </p>
                  <p 
                    className="text-gray-600 text-sm ceo-signature-title"
                    style={{ color: 'var(--foreground)' }}
                  >
{t.ceoSignatureTitle}
                  </p>
                </div>
                <div className="mt-12">                </div>
              </Card>
            </div>
          </div>
        </div>
      </section>
      {/* Company Story */}
      <section className="py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 
                className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6 about-story-title"
                style={{ color: 'var(--foreground)' }}
              >
{t.storyTitle}
              </h2>
              <p 
                className="text-gray-600 mb-6 leading-relaxed about-story-description"
                style={{ color: 'var(--foreground)' }}
              >
                {t.storyParagraph1}
              </p>
              <p 
                className="text-gray-600 mb-6 leading-relaxed about-story-description"
                style={{ color: 'var(--foreground)' }}
              >
                {t.storyParagraph2}
              </p>
              <p 
                className="text-gray-600 leading-relaxed about-story-description"
                style={{ color: 'var(--foreground)' }}
              >
                {t.storyParagraph3}
              </p>
            </div>
            <div>
              <ImageWithFallback
                src="aboutus.jpg"
                alt="İlimera Teknoloji Ekibi"
                className="w-full h-auto rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {t.stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-3xl lg:text-4xl font-bold text-primary dark:text-primary mb-2">
                  {stat.value}
                </div>
                <div className="text-gray-600 dark:text-gray-300">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <Card className="p-8 dark:bg-gray-800 dark:border-gray-700">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-primary/20 dark:bg-blue-900/30 rounded-lg flex items-center justify-center mr-4">
                  <Target className="text-primary dark:text-primary" size={24} />
                </div>
                <h3 
                  className="text-2xl font-bold text-gray-900 mission-title"
                  style={{ color: 'var(--foreground)' }}
                >
                  {t.missionTitle}
                </h3>
              </div>
              <p 
                className="text-gray-600 leading-relaxed mission-description"
                style={{ color: 'var(--foreground)' }}
              >
                {t.missionDescription}
              </p>
            </Card>

            <Card className="p-8 dark:bg-gray-800 dark:border-gray-700">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-primary/20 dark:bg-blue-900/30 rounded-lg flex items-center justify-center mr-4">
                  <Eye className="text-primary dark:text-blue-400" size={24} />
                </div>
                <h3 
                  className="text-2xl font-bold text-gray-900 vision-title"
                  style={{ color: 'var(--foreground)' }}
                >
                  {t.visionTitle}
                </h3>
              </div>
              <p 
                className="text-gray-600 leading-relaxed vision-description"
                style={{ color: 'var(--foreground)' }}
              >
                {t.visionDescription}
              </p>
            </Card>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 
              className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4 values-title"
              style={{ color: 'var(--foreground)' }}
            >
              {t.valuesTitle}
            </h2>
            <p 
              className="text-lg text-gray-600 values-description"
              style={{ color: 'var(--foreground)' }}
            >
              {t.valuesDescription}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {t.values.map((value, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-primary/20 dark:bg-blue-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
                  <value.icon className="text-primary dark:text-blue-400" size={32} />
                </div>
                <h3 
                  className="text-xl font-semibold text-gray-900 mb-2 values-item-title"
                  style={{ color: 'var(--foreground)' }}
                >
                  {value.title}
                </h3>
                <p 
                  className="text-gray-600 values-item-description"
                  style={{ color: 'var(--foreground)' }}
                >
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}